import { render, staticRenderFns } from "./SimulacaoVisualizar.vue?vue&type=template&id=1f862b7c"
import script from "./SimulacaoVisualizar.vue?vue&type=script&lang=js"
export * from "./SimulacaoVisualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports